import React, { useEffect, useMemo, useRef, useState } from "react";
import { useContext } from "react";
import { UserContext } from "../context/UserContext";
import { db, auth } from "../firebase/firebaseConfig";

import Alertas from "./Alertas";
import EnviarCorreo from "../funciones/EnviarCorreo";

import {
    getDocs,
    collection,
    where,
    query,
    updateDoc,
    doc,
    onSnapshot,
} from "firebase/firestore";

import moment from "moment";
import ReactDOMServer from "react-dom/server";
import { PDFViewer } from "@react-pdf/renderer";
import Presupuesto from "./ReportePresupuestoPDF";
import ReporteBajaSTPDF from "./ReporteBajaSTPDF";
import {
    Container,
    Segment,
    Table,
    Input,
    Form,
    Dropdown,
    Icon,
    Modal,
    Button,
    Header,
    Message,
    Checkbox,
    Label
} from "semantic-ui-react";

const Entregar = () => {
    const fechaHoy = new Date();
    const user = auth.currentUser;
    const { users } = useContext(UserContext);

    const [alerta, cambiarAlerta] = useState({});
    const [estadoAlerta, cambiarEstadoAlerta] = useState(false);

    const [realizados, setRealizados] = useState([]);
    const [mostrarDet, setMostrarDet] = useState([]);
    const [testIngreso, setTestIngreso] = useState([]);
    const [alertaOrdenIngreso, setAlertaOrdenIngreso] = useState([]);
    const [buscador, setBuscador] = useState("");

    // Modales
    const [openDetalle, setOpenDetalle] = useState(false);
    const [openCame, setOpenCame] = useState(false);
    const [openCodigo, setOpenCodigo] = useState(false);
    const [openPdf, setOpenPdf] = useState(false);

    // Datos fila seleccionada
    const [datos, setDatos] = useState(null);

    // Came (boleta/monto o sin cobro)
    const [boleta, setBoleta] = useState("");
    const [monto, setMonto] = useState("");
    const [checked, setChecked] = useState(false);
    const [motivo, setMotivo] = useState("");

    // Código entrega
    const [codigo, setCodigo] = useState("");
    const [nombre_out, setNombre_out] = useState("");
    const [correo_out, setCorreo_out] = useState("");
    const [telefono_out, setTelefono_out] = useState("");


    // cooldown enviar código
    const [btnEnviarCodigo, setBtnEnviarCodigo] = useState(false);
    const [tiempo, setTiempo] = useState(30);
    const timerRef = useRef(null);

    // Presupuesto PDF
    const [usuarioIngreso, setUsuarioIngreso] = useState([]);
    const [userAdd, setUsersAdd] = useState([]);
    const [cabecera, setCabecera] = useState([]);
    const [presup, setPresu] = useState([]);
    const [falla, setFalla] = useState([]);
    const [total, setTotal] = useState(0);
    const idCab = useRef(null);

    // =========================
    // Certificado Baja ST
    // =========================
    const [openPdfBaja, setOpenPdfBaja] = useState(false);
    const [loadingPdfBajaId, setLoadingPdfBajaId] = useState(null);
    const [presupuestosCabMap, setPresupuestosCabMap] = useState({});

    const [bajaIngreso, setBajaIngreso] = useState(null);
    const [bajaPresupuestoCab, setBajaPresupuestoCab] = useState(null);
    const [bajaPresupuesto, setBajaPresupuesto] = useState([]);
    const [bajaBitacoraCab, setBajaBitacoraCab] = useState(null);
    const [bajaBitacora, setBajaBitacora] = useState([]);
    const [bajaRegistro, setBajaRegistro] = useState(null);
    const [bajaUsuario, setBajaUsuario] = useState([]);

    const [ordenListado, setOrdenListado] = useState("antiguas");

    const motivos = useMemo(
        () => [
            { key: 1, text: "Autorizado por Gerencia", value: "Autorizado por Gerencia" },
            { key: 2, text: "Descuento Cliente Vip", value: "Descuento Cliente Vip" },
            { key: 3, text: "Renovación de equipo", value: "Renovación de equipo" },
            { key: 4, text: "Garantía", value: "Garantía" },
        ],
        []
    );

    const resetAlerta = () => {
        cambiarEstadoAlerta(false);
        cambiarAlerta({});
    };

    const formatearFecha = (fecha) => {
        if (!fecha?.toDate) return "";
        return moment(fecha.toDate()).format("DD/MM/YYYY HH:mm");
    };

    const calcularDiasEspera = (fecha) => {
        if (!fecha) return null;

        const fechaCierre =
            typeof fecha.toDate === "function"
                ? fecha.toDate()
                : new Date(fecha);

        if (Number.isNaN(fechaCierre.getTime())) return null;

        const hoy = moment().startOf("day");
        const cierre = moment(fechaCierre).startOf("day");

        return Math.max(0, hoy.diff(cierre, "days"));
    };

    // =========================
    // Lecturas
    // =========================
    const consultarUsuario = async () => {
        if (!users?.emp_id) return;
        const qUser = query(collection(db, "usuarios"), where("emp_id", "==", users.emp_id));
        const snap = await getDocs(qUser);
        setUsuarioIngreso(snap.docs.map((d) => ({ ...d.data(), id: d.id })));
    };

    const getAlertasOrdenIngreso = async () => {
        if (!users?.emp_id) return;
        const qAlert = query(
            collection(db, "usuariosalertas"),
            where("emp_id", "==", users.emp_id),
            where("tecnico", "==", true)
        );
        const snap = await getDocs(qAlert);
        setAlertaOrdenIngreso(snap.docs.map((d) => ({ ...d.data(), id: d.id })));
    };

    const leerIngresoCab = async (id) => {
        const docum = realizados.filter((r) => r.id === id);
        setMostrarDet(docum);
    };

    const leerTestIngreso = async (id) => {
        if (!users?.emp_id) return;
        const qTest = query(collection(db, "testingreso"), where("id_cab_inst", "==", id));
        const snap = await getDocs(qTest);
        const arr = snap.docs.map((d) => ({ ...d.data(), id: d.id }));
        arr.sort((a, b) => a.fechamod - b.fechamod);
        setTestIngreso(arr);
    };

    // ============================================================
    // ORDENAMIENTO DE ÓRDENES PENDIENTES DE ENTREGA
    // ============================================================

    const realizadosOrd = useMemo(() => {

        const obtenerFecha = (fecha) => {
            if (!fecha) return null;

            if (typeof fecha.toMillis === "function") {
                return fecha.toMillis();
            }

            if (typeof fecha.toDate === "function") {
                return fecha.toDate().getTime();
            }

            const ms = new Date(fecha).getTime();

            return Number.isNaN(ms) ? null : ms;
        };

        return [...realizados].sort((a, b) => {

            // Ordenamiento original por folio
            if (ordenListado === "folio") {
                return Number(b.folio ?? 0) - Number(a.folio ?? 0);
            }

            const fechaA = obtenerFecha(a.fecha_out);
            const fechaB = obtenerFecha(b.fecha_out);

            // Órdenes sin fecha al final
            if (fechaA === null && fechaB === null) {
                return Number(b.folio ?? 0) - Number(a.folio ?? 0);
            }

            if (fechaA === null) return 1;
            if (fechaB === null) return -1;

            // Más recientes primero
            if (ordenListado === "recientes") {
                return (
                    fechaB - fechaA ||
                    Number(b.folio ?? 0) - Number(a.folio ?? 0)
                );
            }

            // Más antiguas primero (predeterminado)
            return (
                fechaA - fechaB ||
                Number(a.folio ?? 0) - Number(b.folio ?? 0)
            );

        });

    }, [realizados, ordenListado]);

    const filteredData = useMemo(() => {
        const q = (buscador || "").trim().toLowerCase();

        // ✅ SI NO HAY BÚSQUEDA → MUESTRA TODO
        if (!q) return realizadosOrd;

        return realizadosOrd.filter((item) =>
            Object.keys(item).some((key) => {
                const raw = item[key];
                const value =
                    ["date", "fecha_out", "fechamod"].includes(key) && raw?.toDate
                        ? moment(raw.toDate()).format("DD/MM/YYYY HH:mm")
                        : String(raw ?? "");
                return value.toLowerCase().includes(q);
            })
        );
    }, [buscador, realizadosOrd]);

    // =========================
    // Timer (evita fugas)
    // =========================
    const stopTimer = () => {
        if (timerRef.current) clearInterval(timerRef.current);
        timerRef.current = null;
    };

    /* const generarNumeroWhatsapp = async (dato) => {
        resetAlerta();
        if (!dato?.id) return;

        setBtnEnviarCodigo(true);

        const numeroAleatorio = Math.floor(Math.random() * 900000) + 100000;

        if (!nombre_out.trim()) {
            cambiarEstadoAlerta(true);
            cambiarAlerta({ tipo: "error", mensaje: "Debe ingresar un Nombre de Retiro" });
            setBtnEnviarCodigo(false);
            return;
        }

        if (!telefono_out.trim()) {
            cambiarEstadoAlerta(true);
            cambiarAlerta({ tipo: "error", mensaje: "Debe ingresar un teléfono de retiro" });
            setBtnEnviarCodigo(false);
            return;
        }

        try {
            setTiempo(30);
            iniciarCuentaRegresiva();

            const nom = nombre_out.toUpperCase().trim();

            await updateDoc(doc(db, "codigos", dato.id), {
                codigo: numeroAleatorio,
                nombre_out: nom,
                correo_out: (correo_out || "").trim(),
                usermod: user?.email || "",
                fechamod: fechaHoy,
            });
            const baseUrlW = process.env.REACT_APP_ENVIAR_WHATSAPP_URL;
            const resp = await fetch(`${baseUrlW}`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    telefono: telefono_out.trim(),
                    codigo: String(numeroAleatorio),
                }),
            });

            const data = await resp.json();

            if (!resp.ok) {
                throw new Error(data?.error || "No se pudo enviar el WhatsApp");
            }

            cambiarEstadoAlerta(true);
            cambiarAlerta({
                tipo: "exito",
                mensaje: "Código enviado por WhatsApp con éxito. El anterior quedó inválido.",
            });
        } catch (error) {
            console.error(error);
            cambiarEstadoAlerta(true);
            cambiarAlerta({
                tipo: "error",
                mensaje: error?.message || "No se pudo enviar WhatsApp",
            });
        } finally {
            setTimeout(() => setBtnEnviarCodigo(false), 30000);
        }
    }; */

    const iniciarCuentaRegresiva = () => {
        stopTimer();
        timerRef.current = setInterval(() => {
            setTiempo((prev) => {
                if (prev <= 1) {
                    stopTimer();
                    return 0;
                }
                return prev - 1;
            });
        }, 1000);
    };

    useEffect(() => {
        return () => stopTimer();
    }, []);

    // =========================
    // Email: código entrega
    // =========================
    const cuerpoCorreoCodigo = (codigo6) => {
        return ReactDOMServer.renderToString(
            <div style={{ backgroundColor: "#EEF2EF", textAlign: "center", padding: "40px" }}>
                <img
                    src={`https://logisticmed.cl/${users?.emp_id}.png`}
                    alt="Logo"
                    style={{ width: "30%" }}
                />
                <br />
                <div style={{ backgroundColor: "#EAF1FB" }}>
                    <h3>Su código para entrega del producto es: {codigo6}</h3>
                </div>
                <div>
                    <h5>
                        Estimado cliente, por favor entregue este código cuando el técnico se lo solicite, al
                        momento de retirar su equipo.
                    </h5>
                </div>
                <div>
                    <h5 style={{ fontSize: "0.75rem" }}>
                        soporte@dormirbien.cl - General Parra#674 Of.H - +56976321481
                    </h5>
                </div>
            </div>
        );
    };

    // Email: notificación entrega a usuariosalertas
    const cuerpoCorreoEntrega = (data) => {
        const d = data?.[0] || {};
        const Safe = (v, fb = "-") => (v === null || v === undefined || v === "" ? fb : String(v));

        const wrap = { backgroundColor: "#EEF2EF", textAlign: "center", padding: "24px" };
        const card = {
            backgroundColor: "#EAF1FB",
            margin: "0 auto",
            width: "100%",
            maxWidth: "640px",
            textAlign: "left",
        };
        const header = {
            backgroundColor: "#3A9A9D",
            fontSize: "20px",
            color: "#ffffff",
            margin: 0,
            padding: "14px 18px",
            textAlign: "center",
        };
        const sectionTitle = {
            padding: "12px 16px",
            fontSize: "18px",
            textAlign: "left",
            margin: 0,
            fontWeight: 600,
        };
        const tableBase = {
            borderCollapse: "collapse",
            border: "4px solid #C8C8C8",
            width: "100%",
            tableLayout: "fixed",
            letterSpacing: "0.2px",
            fontSize: "14px",
            backgroundColor: "#FFFFFF",
        };
        const th = {
            border: "4px solid #BEBEBE",
            padding: "10px 12px",
            backgroundColor: "#EBEBEB",
            textAlign: "left",
            verticalAlign: "top",
            width: "40%",
            wordBreak: "break-word",
            overflowWrap: "anywhere",
        };
        const td = {
            border: "4px solid #BEBEBE",
            padding: "10px 12px",
            backgroundColor: "#F5F5F5",
            textAlign: "left",
            verticalAlign: "top",
            wordBreak: "break-word",
            overflowWrap: "anywhere",
        };

        const Row = ({ label, value, valueStyle }) => (
            <tr>
                <th style={th}>{label}</th>
                <td style={{ ...td, ...(valueStyle || {}) }}>{Safe(value)}</td>
            </tr>
        );

        return ReactDOMServer.renderToString(
            <table role="presentation" width="100%" cellPadding="0" cellSpacing="0" style={{ backgroundColor: "#EEF2EF" }}>
                <tbody>
                    <tr>
                        <td align="center" style={wrap}>
                            <div style={{ ...card, padding: 0 }}>
                                <h2 style={header}>
                                    El usuario {users?.nombre} {users?.apellido} ha entregado la Orden N° {Safe(d.folio)}
                                </h2>

                                <h3 style={sectionTitle}>Información Cliente</h3>
                                <table role="presentation" cellPadding="0" cellSpacing="0" style={tableBase}>
                                    <tbody>
                                        <Row label="Rut" value={d.rut} />
                                        <Row label="Nombre" value={d.entidad} />
                                        <Row label="Fecha" value={d.date ? formatearFecha(d.date) : "-"} />
                                        <Row label="Teléfono" value={d.telefono} />
                                        <Row label="Dirección" value={d.direccion} />
                                        <Row label="Correo" value={d.correo} />
                                    </tbody>
                                </table>

                                <h3 style={sectionTitle}>Información Equipo</h3>
                                <table role="presentation" cellPadding="0" cellSpacing="0" style={tableBase}>
                                    <tbody>
                                        <Row label="Familia" value={d.familia} />
                                        <Row label="Tipo Equipamiento" value={d.tipo} />
                                        <Row label="Marca" value={d.marca} />
                                        <Row label="Modelo" value={d.modelo} />
                                        <Row label="Serie" value={d.serie} />
                                        <Row
                                            label="Servicio"
                                            value={d.servicio}
                                            valueStyle={{ color: "red", fontWeight: 600 }}
                                        />
                                    </tbody>
                                </table>

                                <h3 style={sectionTitle}>Observaciones</h3>
                                <table role="presentation" cellPadding="0" cellSpacing="0" style={tableBase}>
                                    <tbody>
                                        <Row label="Detalle" value={d.observaciones} />
                                    </tbody>
                                </table>

                                <div style={{ height: "24px" }} />
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        );
    };

    // =========================
    // Guardar boleta / sin cobro
    // =========================
    const guardarBoleta = async (dato) => {
        resetAlerta();
        if (!dato?.id) return;

        try {
            if (!checked) {
                if (!boleta) {
                    cambiarEstadoAlerta(true);
                    cambiarAlerta({ tipo: "error", mensaje: "Campo boleta no puede estar vacío" });
                    return;
                }
                if (!monto) {
                    cambiarEstadoAlerta(true);
                    cambiarAlerta({ tipo: "error", mensaje: "Campo monto no puede estar vacío" });
                    return;
                }

                await updateDoc(doc(db, "ingresostcab", dato.id), {
                    boleta: String(boleta),
                    monto: Number(monto),
                    usermod: user?.email || "",
                    fechamod: fechaHoy,
                });
            } else {
                if (!motivo) {
                    cambiarEstadoAlerta(true);
                    cambiarAlerta({ tipo: "error", mensaje: "Seleccione motivo" });
                    return;
                }

                await updateDoc(doc(db, "ingresostcab", dato.id), {
                    motivo,
                    usermod: user?.email || "",
                    fechamod: fechaHoy,
                });
            }

            cambiarEstadoAlerta(true);
            cambiarAlerta({ tipo: "exito", mensaje: "Datos guardados correctamente" });

            // Reset y pasar a flujo código
            setOpenCame(false);
            setOpenCodigo(true);

            setBoleta("");
            setMonto("");
            setMotivo("");
            setChecked(false);

            // precargar retiro
            setNombre_out(dato.entidad || "");
            setCorreo_out(dato.correo || "");
            setTelefono_out(dato.telefono || "");
            setCodigo("");
        } catch (error) {
            console.error(error);
            cambiarEstadoAlerta(true);
            cambiarAlerta({ tipo: "error", mensaje: "Error al guardar datos" });
        }
    };

    // =========================
    // Generar y enviar código
    // =========================
    const generarNumero = async (dato) => {
        resetAlerta();
        if (!dato?.id) return;

        setBtnEnviarCodigo(true);

        const expresionRegular = /[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+/;
        const numeroAleatorio = Math.floor(Math.random() * 900000) + 100000;

        if (!nombre_out.trim()) {
            cambiarEstadoAlerta(true);
            cambiarAlerta({ tipo: "error", mensaje: "Debe ingresar un Nombre de Retiro" });
            setBtnEnviarCodigo(false);
            return;
        }
        if (!correo_out.trim()) {
            cambiarEstadoAlerta(true);
            cambiarAlerta({ tipo: "error", mensaje: "Debe ingresar un correo de Retiro" });
            setBtnEnviarCodigo(false);
            return;
        }
        if (!expresionRegular.test(correo_out)) {
            cambiarEstadoAlerta(true);
            cambiarAlerta({ tipo: "error", mensaje: "Favor ingresar un correo válido" });
            setBtnEnviarCodigo(false);
            return;
        }

        try {
            setTiempo(30);
            iniciarCuentaRegresiva();

            const nom = nombre_out.toUpperCase().trim();

            await updateDoc(doc(db, "codigos", dato.id), {
                codigo: numeroAleatorio,
                nombre_out: nom,
                correo_out: correo_out.trim(),
                usermod: user?.email || "",
                fechamod: fechaHoy,
            });

            console.log("Datos para correo:", { correo_out: correo_out.trim(), numeroAleatorio });
            EnviarCorreo(correo_out.trim(), "Codigo de Entrega:", cuerpoCorreoCodigo(numeroAleatorio));

            cambiarEstadoAlerta(true);
            cambiarAlerta({ tipo: "exito", mensaje: "Código enviado a cliente con éxito" });
        } catch (error) {
            console.error(error);
            cambiarEstadoAlerta(true);
            cambiarAlerta({ tipo: "error", mensaje: "No se pudo generar/enviar el código" });
        } finally {
            // cooldown botón 30s
            setTimeout(() => setBtnEnviarCodigo(false), 30000);
        }
    };

    // Generar y enviar código por SMS
    const generarNumeroSms = async (dato) => {
        resetAlerta();
        if (!dato?.id) return;

        setBtnEnviarCodigo(true);

        const numeroAleatorio = Math.floor(Math.random() * 900000) + 100000;

        if (!nombre_out.trim()) {
            cambiarEstadoAlerta(true);
            cambiarAlerta({ tipo: "error", mensaje: "Debe ingresar un Nombre de Retiro" });
            setBtnEnviarCodigo(false);
            return;
        }

        if (!telefono_out.trim()) {
            cambiarEstadoAlerta(true);
            cambiarAlerta({ tipo: "error", mensaje: "El cliente no tiene teléfono registrado" });
            setBtnEnviarCodigo(false);
            return;
        }

        try {
            setTiempo(30);
            iniciarCuentaRegresiva();

            const nom = nombre_out.toUpperCase().trim();

            await updateDoc(doc(db, "codigos", dato.id), {
                codigo: numeroAleatorio,
                nombre_out: nom,
                correo_out: (correo_out || "").trim(),
                usermod: user?.email || "",
                fechamod: fechaHoy,
            });
            const baseUrl = process.env.REACT_APP_ENVIAR_SMS_URL;
            const resp = await fetch(`${baseUrl}`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    telefono: telefono_out.trim(),
                    codigo: String(numeroAleatorio),
                }),
            });

            const data = await resp.json();

            if (!resp.ok) {
                throw new Error(data?.error || "No se pudo enviar el SMS");
            }

            cambiarEstadoAlerta(true);
            cambiarAlerta({
                tipo: "exito",
                mensaje: "Código enviado por SMS con éxito. El anterior quedó inválido.",
            });
        } catch (error) {
            console.error(error);
            cambiarEstadoAlerta(true);
            cambiarAlerta({
                tipo: "error",
                mensaje: error?.message || "No se pudo generar/enviar el código por SMS",
            });
        } finally {
            setTimeout(() => setBtnEnviarCodigo(false), 30000);
        }
    };

    // =========================
    // Validar código
    // =========================
    const validarNumero = async (dato) => {
        resetAlerta();
        if (!dato?.id) return;

        const codQ = query(
            collection(db, "codigos"),
            where("emp_id", "==", users.emp_id),
            where("folio", "==", dato.folio)
        );
        const snap = await getDocs(codQ);
        const existeCod = snap.docs.map((d) => ({ ...d.data(), id: d.id }));

        if (existeCod.length === 0) {
            cambiarEstadoAlerta(true);
            cambiarAlerta({ tipo: "error", mensaje: "No existe Folio de entrega para esta orden" });
            return;
        }
        if (!codigo) {
            cambiarEstadoAlerta(true);
            cambiarAlerta({ tipo: "error", mensaje: "Debe ingresar un código" });
            return;
        }

        const codigoDb = Number(existeCod[0].codigo);
        const codigoIn = Number(codigo);

        if (codigoDb !== codigoIn) {
            cambiarEstadoAlerta(true);
            cambiarAlerta({ tipo: "error", mensaje: "No coincide el código, vuelva a ingresarlo" });
            return;
        }

        try {
            await updateDoc(doc(db, "ingresostcab", dato.id), {
                estado: "ENTREGADO",
                usermod: user?.email || "",
                fechamod: fechaHoy,
            });

            cambiarEstadoAlerta(true);
            cambiarAlerta({ tipo: "exito", mensaje: "Orden liberada como ENTREGADO" });

            // Enviar correo interno de entrega
            try {
                const msj = realizados.filter((r) => r.folio === dato.folio);
                const mensaje = cuerpoCorreoEntrega(msj);
                alertaOrdenIngreso.forEach((destino) => {
                    EnviarCorreo(destino.correo, "Orden de ingreso Entregada", mensaje);
                });
            } catch (e) {
                console.log("Error enviando correo interno", e);
            }

            // Reset modal
            setNombre_out("");
            setCorreo_out("");
            setCodigo("");
            setOpenCodigo(false);
        } catch (error) {
            console.error(error);
            cambiarEstadoAlerta(true);
            cambiarAlerta({ tipo: "error", mensaje: "Error al actualizar estado a ENTREGADO" });
        }
    };

    // =========================
    // Ver PDF presupuesto
    // =========================
    const verPdf = async (id) => {


        try {
            const datosFiltrados = realizados.filter((item) => item.id === id);
            setCabecera(datosFiltrados);

            const preCab = query(
                collection(db, "presupuestoscab"),
                where("emp_id", "==", users.emp_id),
                where("id_cab_inst", "==", id)
            );
            const presuCab = await getDocs(preCab);
            const existePreCab = presuCab.docs.map((d) => ({ ...d.data(), id: d.id }));
            if (!existePreCab?.[0]?.id) {
                cambiarEstadoAlerta(true);
                cambiarAlerta({ tipo: "error", mensaje: "No existe presupuesto para esta orden" });
                return;
            }
            idCab.current = existePreCab[0].id;

            const pre = query(
                collection(db, "presupuestos"),
                where("emp_id", "==", users.emp_id),
                where("id_cab_pre", "==", idCab.current)
            );
            const presus = await getDocs(pre);
            const existePresupuesto = presus.docs.map((d) => ({ ...d.data(), id: d.id }));

            setPresu(existePresupuesto.filter((p) => p.categoria === "REPUESTO" || p.categoria === "SERVICIO"));
            setFalla(existePresupuesto.filter((f) => f.categoria === "FALLA"));
            setTotal(existePresupuesto.reduce((acc, d) => acc + (Number(d.price) || 0), 0));

            if (datosFiltrados.length > 0) {
                const useradd = datosFiltrados[0].tecnico;
                const usuarioFiltrado = usuarioIngreso.filter((u) => u.correo === useradd);
                setUsersAdd(usuarioFiltrado);
            }

            setOpenPdf(true);
        } catch (error) {
            console.error(error);
            cambiarEstadoAlerta(true);
            cambiarAlerta({ tipo: "error", mensaje: "Error al obtener PDF de presupuesto" });
        }
    };

    // =========================
    // Ver Certificado Baja ST
    // =========================
    const verPdfBajaST = async (item) => {

        resetAlerta();

        if (!item?.id || !users?.emp_id) return;
        setLoadingPdfBajaId(item.id)
        try {
            // =========================
            // 1. INGRESO
            // =========================
            setBajaIngreso(item);

            // =========================
            // 2. CABECERA PRESUPUESTO
            // =========================
            const cabPre =
                presupuestosCabMap[item.id];

            if (!cabPre?.id) {
                cambiarEstadoAlerta(true);
                cambiarAlerta({
                    tipo: "error",
                    mensaje:
                        "No existe presupuesto asociado a esta orden.",
                });

                return;
            }

            if (
                cabPre.tipo_resolucion !==
                "BAJA_ST"
            ) {
                cambiarEstadoAlerta(true);
                cambiarAlerta({
                    tipo: "error",
                    mensaje:
                        "Esta orden no corresponde a una Baja ST.",
                });

                return;
            }

            if (
                cabPre.estado_baja !==
                "REALIZADA"
            ) {
                cambiarEstadoAlerta(true);
                cambiarAlerta({
                    tipo: "error",
                    mensaje:
                        "La Baja ST todavía no se encuentra finalizada.",
                });

                return;
            }

            setBajaPresupuestoCab(cabPre);

            // =========================
            // 3. DETALLE PRESUPUESTO
            // =========================
            const qPresu = query(
                collection(
                    db,
                    "presupuestos"
                ),
                where(
                    "emp_id",
                    "==",
                    users.emp_id
                ),
                where(
                    "id_cab_pre",
                    "==",
                    cabPre.id
                )
            );

            const snapPresu =
                await getDocs(qPresu);

            const detallePresu =
                snapPresu.docs.map(
                    (d) => ({
                        ...d.data(),
                        id: d.id,
                    })
                );

            setBajaPresupuesto(
                detallePresu
            );

            // =========================
            // 4. CABECERA BITÁCORA
            // =========================
            const qBitCab = query(
                collection(
                    db,
                    "bitacoracabpresu"
                ),
                where(
                    "emp_id",
                    "==",
                    users.emp_id
                ),
                where(
                    "id_ingreso",
                    "==",
                    item.id
                )
            );

            const snapBitCab =
                await getDocs(qBitCab);

            const bitCabs =
                snapBitCab.docs.map(
                    (d) => ({
                        ...d.data(),
                        id: d.id,
                    })
                );

            /*
             * Buscamos específicamente
             * la ejecución BAJA_ST
             * del presupuesto actual.
             */
            const cabBit =
                bitCabs
                    .filter(
                        (b) =>
                            b.id_presupuesto ===
                            cabPre.id &&
                            b.tipo_resolucion ===
                            "BAJA_ST" &&
                            b.confirmado === true
                    )
                    .sort(
                        (a, b) =>
                            (b.fechamod?.toMillis?.() ??
                                0) -
                            (a.fechamod?.toMillis?.() ??
                                0)
                    )[0];

            if (!cabBit?.id) {
                cambiarEstadoAlerta(true);
                cambiarAlerta({
                    tipo: "error",
                    mensaje:
                        "No se encontró la ejecución técnica finalizada de la Baja ST.",
                });

                return;
            }

            setBajaBitacoraCab(
                cabBit
            );

            // =========================
            // 5. DETALLE BITÁCORA
            // =========================
            const qBit = query(
                collection(
                    db,
                    "bitacorapresu"
                ),
                where(
                    "emp_id",
                    "==",
                    users.emp_id
                ),
                where(
                    "id_cab_pre",
                    "==",
                    cabBit.id
                )
            );

            const snapBit =
                await getDocs(qBit);

            const detalleBit =
                snapBit.docs.map(
                    (d) => ({
                        ...d.data(),
                        id: d.id,
                    })
                );

            setBajaBitacora(
                detalleBit
            );

            // =========================
            // 6. BAJA EQUIPO
            // =========================
            const qBaja = query(
                collection(
                    db,
                    "bajaEquipos"
                ),
                where(
                    "emp_id",
                    "==",
                    users.emp_id
                ),
                where(
                    "serie",
                    "==",
                    item.serie
                )
            );

            const snapBaja =
                await getDocs(qBaja);

            const bajas =
                snapBaja.docs.map(
                    (d) => ({
                        ...d.data(),
                        id: d.id,
                    })
                );

            /*
             * Todavía mantenemos compatibilidad
             * con registros antiguos que no
             * tienen activo/tipo_baja.
             */
            const bajaEncontrada =
                bajas.find(
                    (b) =>
                        b.id_cab_inst ===
                        item.id
                ) ||
                bajas.find(
                    (b) =>
                        b.tipo_baja ===
                        "BAJA_ST" &&
                        b.activo !== false
                ) ||
                bajas[0] ||
                null;

            setBajaRegistro(
                bajaEncontrada
            );

            // =========================
            // 7. TÉCNICO
            // =========================
            const correoTecnico =
                item.tecnico ||
                cabBit.usermod ||
                cabBit.useradd ||
                "";

            const tecnico =
                usuarioIngreso.filter(
                    (u) =>
                        u.correo ===
                        correoTecnico
                );

            setBajaUsuario(tecnico);

            // =========================
            // 8. ABRIR PDF
            // =========================
            setOpenPdfBaja(true);

        } catch (error) {
            console.error(
                "Error generando Certificado Baja ST:",
                error
            );

            cambiarEstadoAlerta(true);

            cambiarAlerta({
                tipo: "error",
                mensaje:
                    error?.message ||
                    "No fue posible generar el Certificado de Baja ST.",
            });
        } finally {
            setLoadingPdfBajaId(null);
        }
    };

    // =========================
    // Cargar cabeceras de presupuesto
    // para identificar BAJA_ST
    // =========================
    const cargarPresupuestosCab = async () => {
        if (!users?.emp_id) return;

        try {
            const qCab = query(
                collection(db, "presupuestoscab"),
                where("emp_id", "==", users.emp_id)
            );

            const snap = await getDocs(qCab);

            const mapa = {};

            snap.docs.forEach((d) => {
                const data = {
                    ...d.data(),
                    id: d.id,
                };

                /*
                 * La relación con ingresostcab
                 * es id_cab_inst.
                 */
                if (data.id_cab_inst) {
                    /*
                     * Por ahora tomamos la cabecera más reciente
                     * si existiera más de una para una misma orden.
                     */
                    const actual = mapa[data.id_cab_inst];

                    if (!actual) {
                        mapa[data.id_cab_inst] = data;
                    } else {
                        const fechaActual =
                            actual.fechamod?.toMillis?.() ?? 0;

                        const fechaNueva =
                            data.fechamod?.toMillis?.() ?? 0;

                        if (fechaNueva >= fechaActual) {
                            mapa[data.id_cab_inst] = data;
                        }
                    }
                }
            });

            setPresupuestosCabMap(mapa);

        } catch (error) {
            console.error(
                "Error cargando cabeceras de presupuesto:",
                error
            );
        }
    };

    // =========================
    // Snapshot realizados
    // =========================
    useEffect(() => {
        if (!users?.emp_id) return;

        const qRealizados = query(
            collection(db, "ingresostcab"),
            where("emp_id", "==", users.emp_id),
            where("estado", "==", "REALIZADO"),
            /*  orderBy("folio", "desc") */
        );

        const unsub = onSnapshot(
            qRealizados,
            (snap) => {
                const arr = snap.docs.map((d, index) => ({
                    ...d.data(),
                    id: d.id,
                    id2: index + 1,
                }));
                setRealizados(arr);
            },
            (error) => console.error("onSnapshot realizados error:", error)
        );

        return () => unsub();
    }, [users?.emp_id]);

    useEffect(() => {
        getAlertasOrdenIngreso();
        consultarUsuario();
        cargarPresupuestosCab();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [users?.emp_id]);

    // =========================
    // UI helpers
    // =========================
    const handleOpenDetalle = async (item) => {
        resetAlerta();
        setDatos(item);
        await leerIngresoCab(item.id);
        await leerTestIngreso(item.id);
        setOpenDetalle(true);
    };

    const esIngresoHomeCare = (item) => {
        return item?.origen_ingreso === "TRASPASO_ST_INTERNO";
    };

    const entregarATransportista = async (dato) => {
        resetAlerta();

        if (!dato?.id) {
            cambiarEstadoAlerta(true);
            cambiarAlerta({
                tipo: "error",
                mensaje: "No existe una orden seleccionada.",
            });
            return;
        }

        if (
            dato.origen_ingreso !==
            "TRASPASO_ST_INTERNO"
        ) {
            cambiarEstadoAlerta(true);
            cambiarAlerta({
                tipo: "error",
                mensaje:
                    "Esta orden no corresponde a un retorno HomeCare.",
            });
            return;
        }

        if (!dato.emp_id_origen) {
            cambiarEstadoAlerta(true);
            cambiarAlerta({
                tipo: "error",
                mensaje:
                    "La orden no tiene identificada la empresa HomeCare de origen.",
            });
            return;
        }

        try {
            const ahora = new Date();

            // ==========================================
            // 1. BUSCAR TRASPASO ESPEJO
            // ==========================================

            const qRetorno = query(
                collection(db, "salidasCab"),
                where(
                    "emp_id",
                    "==",
                    dato.emp_id_origen
                ),
                where(
                    "origen_traspaso",
                    "==",
                    "RETORNO_ST_INTERNO"
                ),
                where(
                    "id_ingreso_st",
                    "==",
                    dato.id
                )
            );

            const snapRetorno =
                await getDocs(qRetorno);

            if (snapRetorno.empty) {
                cambiarEstadoAlerta(true);
                cambiarAlerta({
                    tipo: "error",
                    mensaje:
                        "No existe un traspaso de retorno asociado a esta orden.",
                });
                return;
            }

            if (snapRetorno.size > 1) {
                cambiarEstadoAlerta(true);
                cambiarAlerta({
                    tipo: "error",
                    mensaje:
                        "Existe más de un traspaso de retorno asociado a esta orden. Revise la trazabilidad.",
                });
                return;
            }

            const retorno = {
                id: snapRetorno.docs[0].id,
                ...snapRetorno.docs[0].data(),
            };

            // ==========================================
            // 2. HOMECARE DEBE HABER CONFIRMADO
            // ==========================================

            if (retorno.confirmado !== true) {
                cambiarEstadoAlerta(true);
                cambiarAlerta({
                    tipo: "error",
                    mensaje:
                        "HomeCare todavía no ha confirmado el traspaso de retorno.",
                });
                return;
            }

            // ==========================================
            // 3. DEBE EXISTIR TRANSPORTISTA
            // ==========================================

            if (!String(retorno.correo || "").trim()) {
                cambiarEstadoAlerta(true);
                cambiarAlerta({
                    tipo: "error",
                    mensaje:
                        "El traspaso no tiene un transportista asignado.",
                });
                return;
            }

            if (!String(retorno.patente || "").trim()) {
                cambiarEstadoAlerta(true);
                cambiarAlerta({
                    tipo: "error",
                    mensaje:
                        "El traspaso no tiene patente de vehículo asignada.",
                });
                return;
            }

            // ==========================================
            // 4. VALIDAR QUE TODAVÍA NO FUE RETIRADO
            // ==========================================

            if (retorno.retirado === true) {
                cambiarEstadoAlerta(true);
                cambiarAlerta({
                    tipo: "error",
                    mensaje:
                        "El transportista ya confirmó el retiro de este equipo.",
                });
                return;
            }

            // ==========================================
            // 5. CAMBIAR ORDEN ST A EN RETIRO
            // ==========================================
            //
            // MUY IMPORTANTE:
            //
            // NO ponemos ENTREGADO.
            // NO modificamos status.
            // NO modificamos retirado.
            //
            // El equipo sigue físicamente bajo el
            // flujo ST hasta que el transportista
            // confirme que lo recibió.
            // ==========================================

            await updateDoc(
                doc(db, "ingresostcab", dato.id),
                {
                    estado: "EN RETIRO",

                    // estado_servicio sigue REALIZADO
                    // porque técnicamente la mantención
                    // ya terminó.

                    usermod: user?.email || "",
                    fechamod: ahora,
                }
            );

            cambiarEstadoAlerta(true);
            cambiarAlerta({
                tipo: "exito",
                mensaje:
                    `Equipo liberado para retiro. ` +
                    `Transportista: ${retorno.correo} - ` +
                    `Patente: ${retorno.patente}.`,
            });

            // No necesitamos sacar manualmente la fila.
            // El onSnapshot consulta únicamente
            // estado == REALIZADO, por lo que desaparecerá
            // automáticamente al quedar EN RETIRO.

        } catch (error) {
            console.error(
                "Error entregando a transportista:",
                error
            );

            cambiarEstadoAlerta(true);
            cambiarAlerta({
                tipo: "error",
                mensaje:
                    error?.message ||
                    "No fue posible liberar el equipo para retiro.",
            });
        }
    };

    const handleOpenEntrega = (item) => {
        resetAlerta();
        setDatos(item);

        // precarga por defecto
        setNombre_out(item.entidad || "");
        setCorreo_out(item.correo || "");
        setTelefono_out(item.telefono || "");
        setCodigo("");

        // si no tiene boleta ni motivo -> primero came, si ya tiene -> directo a código
        const sinPagoRegistrado = (item.boleta == null && item.motivo == null);
        if (sinPagoRegistrado) {
            setOpenCame(true);
        } else {
            setOpenCodigo(true);
        }
    };

    const closeAllEntregaModals = () => {
        setOpenCame(false);
        setOpenCodigo(false);
        setDatos(null);
        setBoleta("");
        setMonto("");
        setMotivo("");
        setChecked(false);
        setNombre_out("");
        setCorreo_out("");
        setTelefono_out("");
        setCodigo("");
        setTiempo(30);
        setBtnEnviarCodigo(false);
        stopTimer();
    };

    return (
        <Container
            fluid
            style={{
                background: "#f8fafc",
                minHeight: "100vh",
                padding: "18px 16px 35px",
            }}
        >
            <Container fluid style={{ maxWidth: 1500 }}>

                {/* ================= CABECERA ================= */}
                <Segment
                    style={{
                        border: "1px solid #e5e7eb",
                        borderRadius: 8,
                        boxShadow: "0 1px 3px rgba(0,0,0,.06)",
                        padding: "18px 20px",
                        marginBottom: 16,
                    }}
                >
                    <div style={{ display: "flex", alignItems: "center", gap: 14 }}>
                        <Label
                            size="massive"
                            style={{
                                background: "#e8f8f7",
                                color: "#00b5ad",
                                margin: 0,
                            }}
                        >
                            <Icon name="pallet" style={{ margin: 0 }} />
                        </Label>

                        <Header as="h2" style={{ margin: 0, color: "#1f2937", fontSize: 21 }}>
                            Equipos para entregar
                            <Header.Subheader style={{ marginTop: 5 }}>
                                Revisa las órdenes finalizadas y gestiona la entrega del equipo
                            </Header.Subheader>
                        </Header>
                    </div>
                </Segment>

                {/* ================= BUSCADOR ================= */}
                <Segment
                    style={{
                        border: "1px solid #e5e7eb",
                        borderRadius: 8,
                        boxShadow: "0 1px 3px rgba(0,0,0,.06)",
                        marginBottom: 16,
                    }}
                >
                    <div
                        style={{
                            display: "flex",
                            gap: 12,
                            alignItems: "center",
                            flexWrap: "wrap",
                        }}
                    >
                        <div style={{ flex: 1, minWidth: 260 }}>
                            <Header as="h4" style={{ marginBottom: 10 }}>
                                <Icon name="search" color="teal" />
                                <Header.Content>
                                    Buscar orden
                                    <Header.Subheader>
                                        Folio, cliente, equipo, serie o servicio
                                    </Header.Subheader>
                                </Header.Content>
                            </Header>

                            <Input
                                fluid
                                focus
                                placeholder="Escriba para buscar..."
                                value={buscador}
                                onChange={(e) => setBuscador(e.target.value)}
                                icon={
                                    buscador
                                        ? {
                                            name: "close",
                                            link: true,
                                            onClick: () => setBuscador(""),
                                            title: "Limpiar",
                                        }
                                        : {
                                            name: "search",
                                            color: "teal",
                                        }
                                }
                            />
                        </div>
                        {/* ORDENAMIENTO */}
                        <div style={{ minWidth: 250, flex: "0 1 280px" }}>

                            <Header as="h4" style={{ marginBottom: 10 }}>
                                <Icon name="sort amount down" color="teal" />
                                <Header.Content>
                                    Ordenar órdenes
                                    <Header.Subheader>
                                        Según fecha de cierre técnico
                                    </Header.Subheader>
                                </Header.Content>
                            </Header>

                            <Dropdown
                                fluid
                                selection
                                value={ordenListado}
                                onChange={(e, { value }) => setOrdenListado(value)}
                                options={[
                                    {
                                        key: "antiguas",
                                        value: "antiguas",
                                        text: "Más antiguas primero",
                                        icon: "sort amount up",
                                    },
                                    {
                                        key: "recientes",
                                        value: "recientes",
                                        text: "Más recientes primero",
                                        icon: "sort amount down",
                                    },
                                    {
                                        key: "folio",
                                        value: "folio",
                                        text: "N° Orden descendente",
                                        icon: "hashtag",
                                    },
                                ]}
                            />

                        </div>
                        <Label
                            basic
                            color="teal"
                            size="large"
                            style={{ marginTop: 28 }}
                        >
                            {filteredData.length} registro(s)
                        </Label>
                    </div>
                </Segment>

                {/* ================= LISTADO ================= */}
                <Segment
                    raised
                    style={{
                        border: "1px solid #e5e7eb",
                        borderRadius: 8,
                        boxShadow: "0 1px 3px rgba(0,0,0,.06)",
                        padding: 0,
                        overflow: "hidden",
                    }}
                >
                    <div
                        style={{
                            padding: "13px 16px",
                            borderBottom: "1px solid #e5e7eb",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                        }}
                    >
                        <Header as="h4" style={{ margin: 0 }}>
                            <Icon name="list alternate outline" color="teal" />
                            <Header.Content>
                                Órdenes disponibles para entrega
                                <Header.Subheader>
                                    Equipos con trabajo técnico finalizado
                                </Header.Subheader>
                            </Header.Content>
                        </Header>
                    </div>

                    <div
                        style={{
                            overflowX: "auto",
                            overflowY: "auto",
                            maxHeight: 520,
                        }}
                    >
                        <Table
                            celled
                            striped
                            selectable
                            compact="very"
                            singleLine
                            style={{
                                fontSize: 11,
                                margin: 0,
                            }}
                        >
                            <Table.Header>
                                <Table.Row>
                                    <Table.HeaderCell
                                        width={1}
                                        textAlign="center"
                                        style={{
                                            position: "sticky",
                                            top: 0,
                                            zIndex: 2,
                                            background: "#f8fafc",
                                        }}
                                    >
                                        #
                                    </Table.HeaderCell>

                                    {[
                                        "N° Orden",
                                        "Fecha Ingreso",
                                        "Equipo",
                                        "Modelo",
                                        "N° Serie",
                                        "Servicio Inicial",
                                        "Servicio Final",
                                        "Fecha Cierre",
                                        "Dias en espera"
                                    ].map((titulo) => (
                                        <Table.HeaderCell
                                            key={titulo}
                                            style={{
                                                position: "sticky",
                                                top: 0,
                                                zIndex: 2,
                                                background: "#f8fafc",
                                                whiteSpace: "nowrap",
                                            }}
                                        >
                                            {titulo}
                                        </Table.HeaderCell>
                                    ))}

                                    <Table.HeaderCell
                                        textAlign="center"
                                        style={{
                                            position: "sticky",
                                            top: 0,
                                            zIndex: 2,
                                            background: "#f8fafc",
                                        }}
                                    >
                                        Detalle
                                    </Table.HeaderCell>

                                    <Table.HeaderCell
                                        textAlign="center"
                                        style={{
                                            position: "sticky",
                                            top: 0,
                                            zIndex: 2,
                                            background: "#f8fafc",
                                        }}
                                    >
                                        Presupuesto
                                    </Table.HeaderCell>

                                    <Table.HeaderCell
                                        textAlign="center"
                                        style={{
                                            position: "sticky",
                                            top: 0,
                                            zIndex: 2,
                                            background: "#f8fafc",
                                        }}
                                    >
                                        Certificado
                                    </Table.HeaderCell>

                                    <Table.HeaderCell
                                        textAlign="center"
                                        style={{
                                            position: "sticky",
                                            top: 0,
                                            zIndex: 2,
                                            background: "#f8fafc",
                                        }}
                                    >
                                        Entregar
                                    </Table.HeaderCell>
                                </Table.Row>
                            </Table.Header>

                            <Table.Body>
                                {filteredData.map((item, index) => (
                                    <Table.Row key={item.id ?? index}>
                                        <Table.Cell textAlign="center">
                                            {index + 1}
                                        </Table.Cell>

                                        {/* ORDEN: sin cuadrado de color */}
                                        <Table.Cell>
                                            <strong>{item.folio}</strong>

                                            {esIngresoHomeCare(item) && (
                                                <div style={{ marginTop: 4 }}>
                                                    <Label
                                                        basic
                                                        color="blue"
                                                        size="mini"
                                                    >
                                                        <Icon name="exchange" />
                                                        HOMECARE
                                                    </Label>
                                                </div>
                                            )}
                                        </Table.Cell>

                                        <Table.Cell>
                                            {formatearFecha(item.date)}
                                        </Table.Cell>

                                        <Table.Cell>{item.tipo}</Table.Cell>

                                        <Table.Cell>{item.modelo}</Table.Cell>

                                        <Table.Cell>{item.serie}</Table.Cell>

                                        <Table.Cell>{item.servicio}</Table.Cell>

                                        <Table.Cell>
                                            <Label
                                                basic
                                                color="teal"
                                                size="tiny"
                                            >
                                                {item.servicionew || "—"}
                                            </Label>
                                        </Table.Cell>

                                        <Table.Cell>
                                            {formatearFecha(item.fecha_out)}
                                        </Table.Cell>
                                        {/* DÍAS EN ESPERA */}
                                        <Table.Cell textAlign="center">
                                            {(() => {
                                                const dias = calcularDiasEspera(item.fecha_out);

                                                if (dias === null) {
                                                    return (
                                                        <Label basic color="grey" size="tiny">
                                                            Sin fecha
                                                        </Label>
                                                    );
                                                }

                                                const color =
                                                    dias >= 15
                                                        ? "red"
                                                        : dias >= 7
                                                            ? "orange"
                                                            : dias >= 3
                                                                ? "yellow"
                                                                : "green";

                                                return (
                                                    <Label
                                                        color={color}
                                                        size="tiny"
                                                        style={{
                                                            minWidth: 65,
                                                            textAlign: "center",
                                                        }}
                                                    >
                                                        {dias} {dias === 1 ? "día" : "días"}
                                                    </Label>
                                                );
                                            })()}
                                        </Table.Cell>

                                        {/* DETALLE */}
                                        <Table.Cell textAlign="center">
                                            <Button
                                                basic
                                                compact
                                                icon
                                                size="mini"
                                                onClick={() => handleOpenDetalle(item)}
                                                title="Ver detalle de ingreso"
                                                style={{
                                                    color: "#2185d0",
                                                    background: "#fff",
                                                    boxShadow: "none",
                                                }}
                                            >
                                                <Icon
                                                    name="eye outline"
                                                    color="blue"
                                                    style={{
                                                        margin: 0,
                                                        fontSize: "1.2em",
                                                    }}
                                                />
                                            </Button>
                                        </Table.Cell>

                                        {/* PRESUPUESTO */}
                                        <Table.Cell textAlign="center">
                                            {item.servicio === "PRESUPUESTO" ? (
                                                <Button
                                                    basic
                                                    compact
                                                    icon
                                                    size="mini"
                                                    onClick={() => verPdf(item.id)}
                                                    title="Ver PDF presupuesto"
                                                    style={{
                                                        color: "#db2828",
                                                        background: "#fff",
                                                        boxShadow: "none",
                                                    }}
                                                >
                                                    <Icon
                                                        name="file pdf outline"
                                                        color="red"
                                                        style={{
                                                            margin: 0,
                                                            fontSize: "1.25em",
                                                        }}
                                                    />
                                                </Button>
                                            ) : (
                                                <Button
                                                    basic
                                                    compact
                                                    icon
                                                    size="mini"
                                                    disabled
                                                    title="No aplica"
                                                >
                                                    <Icon
                                                        name="file pdf outline"
                                                        style={{
                                                            margin: 0,
                                                            fontSize: "1.25em",
                                                        }}
                                                    />
                                                </Button>
                                            )}
                                        </Table.Cell>

                                        {/* CERTIFICADO BAJA ST */}
                                        <Table.Cell textAlign="center">
                                            {presupuestosCabMap[item.id]
                                                ?.tipo_resolucion === "BAJA_ST" &&
                                                presupuestosCabMap[item.id]
                                                    ?.estado_baja === "REALIZADA" ? (
                                                <Button
                                                    basic
                                                    compact
                                                    icon
                                                    size="mini"
                                                    loading={
                                                        loadingPdfBajaId ===
                                                        item.id
                                                    }
                                                    disabled={
                                                        loadingPdfBajaId !== null
                                                    }
                                                    onClick={() =>
                                                        verPdfBajaST(item)
                                                    }
                                                    title="Ver Certificado de Baja ST"
                                                    style={{
                                                        color: "#db2828",
                                                        background: "#fff",
                                                        boxShadow: "none",
                                                    }}
                                                >
                                                    <Icon
                                                        name="file pdf outline"
                                                        color="red"
                                                        style={{
                                                            margin: 0,
                                                            fontSize: "1.25em",
                                                        }}
                                                    />
                                                </Button>
                                            ) : (
                                                <Button
                                                    basic
                                                    compact
                                                    icon
                                                    size="mini"
                                                    disabled
                                                    title="No aplica"
                                                >
                                                    <Icon
                                                        name="file pdf outline"
                                                        style={{
                                                            margin: 0,
                                                            fontSize: "1.25em",
                                                        }}
                                                    />
                                                </Button>
                                            )}
                                        </Table.Cell>

                                        {/* ENTREGA */}
                                        <Table.Cell textAlign="center">
                                            {esIngresoHomeCare(item) ? (
                                                <Button
                                                    color="orange"
                                                    size="mini"
                                                    onClick={() =>
                                                        entregarATransportista(
                                                            item
                                                        )
                                                    }
                                                    title="Liberar equipo para retiro del transportista asignado por HomeCare"
                                                >
                                                    <Icon name="truck" />
                                                    Entregar a transportista
                                                </Button>
                                            ) : (
                                                <Button
                                                    color={
                                                        item.boleta == null &&
                                                            item.motivo == null
                                                            ? "teal"
                                                            : "orange"
                                                    }
                                                    size="mini"
                                                    onClick={() =>
                                                        handleOpenEntrega(item)
                                                    }
                                                    title={
                                                        item.boleta == null &&
                                                            item.motivo == null
                                                            ? "Flujo de entrega (boleta/motivo + código)"
                                                            : "Pendiente enviar Código"
                                                    }
                                                >
                                                    <Icon name="sign-out" />
                                                    Entregar
                                                </Button>
                                            )}
                                        </Table.Cell>
                                    </Table.Row>
                                ))}

                                {filteredData.length === 0 && (
                                    <Table.Row>
                                        <Table.Cell
                                            colSpan="14"
                                            textAlign="center"
                                            style={{
                                                padding: 30,
                                                color: "#6b7280",
                                            }}
                                        >
                                            <Icon
                                                name="inbox"
                                                size="large"
                                                color="grey"
                                            />
                                            <div style={{ marginTop: 8 }}>
                                                No hay resultados con el filtro
                                                actual.
                                            </div>
                                        </Table.Cell>
                                    </Table.Row>
                                )}
                            </Table.Body>
                        </Table>
                    </div>
                </Segment>

                {/* ================= ALERTAS ================= */}
                <Alertas
                    tipo={alerta.tipo}
                    mensaje={alerta.mensaje}
                    estadoAlerta={estadoAlerta}
                    cambiarEstadoAlerta={cambiarEstadoAlerta}
                />

                {/* ================= MODAL DETALLE ================= */}
                <Modal
                    open={openDetalle}
                    onClose={() => setOpenDetalle(false)}
                    size="large"
                    closeIcon
                >
                    <Modal.Header>
                        <Icon name="clipboard outline" color="teal" />
                        Detalle de Ingreso
                    </Modal.Header>

                    <Modal.Content scrolling>
                        <Header as="h4" color="teal">
                            <Icon name="user outline" />
                            Información Cliente
                        </Header>

                        <Table celled compact="very" singleLine>
                            <Table.Header>
                                <Table.Row>
                                    <Table.HeaderCell>N° Orden</Table.HeaderCell>
                                    <Table.HeaderCell>Rut</Table.HeaderCell>
                                    <Table.HeaderCell>Cliente</Table.HeaderCell>
                                    <Table.HeaderCell>Teléfono</Table.HeaderCell>
                                    <Table.HeaderCell>Dirección</Table.HeaderCell>
                                    <Table.HeaderCell>Email</Table.HeaderCell>
                                </Table.Row>
                            </Table.Header>

                            <Table.Body>
                                {mostrarDet.map((it, idx) => (
                                    <Table.Row key={idx}>
                                        <Table.Cell>
                                            <strong>{it.folio}</strong>
                                        </Table.Cell>
                                        <Table.Cell>{it.rut}</Table.Cell>
                                        <Table.Cell>{it.entidad}</Table.Cell>
                                        <Table.Cell>{it.telefono}</Table.Cell>
                                        <Table.Cell>{it.direccion}</Table.Cell>
                                        <Table.Cell>{it.correo}</Table.Cell>
                                    </Table.Row>
                                ))}
                            </Table.Body>
                        </Table>

                        <Header as="h4" color="teal">
                            <Icon name="tasks" />
                            Test de Ingreso
                        </Header>

                        <Table celled compact="very" singleLine>
                            <Table.Header>
                                <Table.Row>
                                    <Table.HeaderCell width={1}>
                                        N
                                    </Table.HeaderCell>
                                    <Table.HeaderCell>
                                        Item
                                    </Table.HeaderCell>
                                    <Table.HeaderCell
                                        width={1}
                                        textAlign="center"
                                    >
                                        Sí
                                    </Table.HeaderCell>
                                    <Table.HeaderCell
                                        width={1}
                                        textAlign="center"
                                    >
                                        No
                                    </Table.HeaderCell>
                                </Table.Row>
                            </Table.Header>

                            <Table.Body>
                                {testIngreso.map((it, idx) => (
                                    <Table.Row key={idx}>
                                        <Table.Cell>
                                            {idx + 1}
                                        </Table.Cell>

                                        <Table.Cell
                                            style={{
                                                whiteSpace: "normal",
                                            }}
                                        >
                                            {it.item}
                                        </Table.Cell>

                                        <Table.Cell textAlign="center">
                                            <Checkbox
                                                checked={it.valorsi}
                                                readOnly
                                            />
                                        </Table.Cell>

                                        <Table.Cell textAlign="center">
                                            <Checkbox
                                                checked={it.valorno}
                                                readOnly
                                            />
                                        </Table.Cell>
                                    </Table.Row>
                                ))}
                            </Table.Body>
                        </Table>

                        {mostrarDet?.[0]?.observaciones && (
                            <Message info>
                                <b>Observaciones:</b>{" "}
                                {mostrarDet[0].observaciones}
                            </Message>
                        )}
                    </Modal.Content>

                    <Modal.Actions>
                        <Button
                            color="teal"
                            onClick={() => setOpenDetalle(false)}
                        >
                            <Icon name="close" />
                            Cerrar
                        </Button>
                    </Modal.Actions>
                </Modal>

                {/* ================= PDF PRESUPUESTO ================= */}
                <Modal
                    open={openPdf}
                    onClose={() => setOpenPdf(false)}
                    size="large"
                    closeIcon
                >
                    <Modal.Header>
                        <Icon name="file pdf outline" color="red" />
                        Presupuesto
                    </Modal.Header>

                    <Modal.Content style={{ padding: 0 }}>
                        <PDFViewer
                            width="100%"
                            height="560"
                            style={{
                                border: "1px solid #ddd",
                            }}
                        >
                            <Presupuesto
                                cabecera={cabecera}
                                falla={falla}
                                presu={presup}
                                total={total}
                                usuario={userAdd}
                                empresa={users.emp_id}
                            />
                        </PDFViewer>
                    </Modal.Content>

                    <Modal.Actions>
                        <Button
                            color="teal"
                            onClick={() => setOpenPdf(false)}
                        >
                            <Icon name="close" />
                            Cerrar
                        </Button>
                    </Modal.Actions>
                </Modal>

                {/* ================= MODAL BOLETA / SIN COBRO ================= */}
                <Modal
                    open={openCame}
                    onClose={closeAllEntregaModals}
                    size="large"
                    closeIcon
                >
                    <Modal.Header>
                        <Icon name="file alternate outline" color="teal" />
                        Documento / Boleta (KAME)
                    </Modal.Header>

                    <Modal.Content scrolling>
                        {datos && (
                            <>
                                <Header as="h4" color="teal">
                                    Información Cliente
                                </Header>

                                <Table celled compact="very" singleLine>
                                    <Table.Header>
                                        <Table.Row>
                                            <Table.HeaderCell>
                                                Folio
                                            </Table.HeaderCell>
                                            <Table.HeaderCell>
                                                Rut
                                            </Table.HeaderCell>
                                            <Table.HeaderCell>
                                                Nombre
                                            </Table.HeaderCell>
                                            <Table.HeaderCell>
                                                Teléfono
                                            </Table.HeaderCell>
                                            <Table.HeaderCell>
                                                Dirección
                                            </Table.HeaderCell>
                                            <Table.HeaderCell>
                                                Email
                                            </Table.HeaderCell>
                                        </Table.Row>
                                    </Table.Header>

                                    <Table.Body>
                                        <Table.Row>
                                            <Table.Cell>
                                                <strong>{datos.folio}</strong>
                                            </Table.Cell>
                                            <Table.Cell>
                                                {datos.rut}
                                            </Table.Cell>
                                            <Table.Cell>
                                                {datos.entidad}
                                            </Table.Cell>
                                            <Table.Cell>
                                                {datos.telefono}
                                            </Table.Cell>
                                            <Table.Cell>
                                                {datos.direccion}
                                            </Table.Cell>
                                            <Table.Cell>
                                                {datos.correo}
                                            </Table.Cell>
                                        </Table.Row>
                                    </Table.Body>
                                </Table>

                                <Header as="h4" color="teal">
                                    Información Equipo
                                </Header>

                                <Table celled compact="very" singleLine>
                                    <Table.Header>
                                        <Table.Row>
                                            <Table.HeaderCell>
                                                Familia
                                            </Table.HeaderCell>
                                            <Table.HeaderCell>
                                                Tipo
                                            </Table.HeaderCell>
                                            <Table.HeaderCell>
                                                Marca
                                            </Table.HeaderCell>
                                            <Table.HeaderCell>
                                                Modelo
                                            </Table.HeaderCell>
                                            <Table.HeaderCell>
                                                Serie
                                            </Table.HeaderCell>
                                            <Table.HeaderCell>
                                                Servicio
                                            </Table.HeaderCell>
                                        </Table.Row>
                                    </Table.Header>

                                    <Table.Body>
                                        <Table.Row>
                                            <Table.Cell>
                                                {datos.familia}
                                            </Table.Cell>
                                            <Table.Cell>
                                                {datos.tipo}
                                            </Table.Cell>
                                            <Table.Cell>
                                                {datos.marca}
                                            </Table.Cell>
                                            <Table.Cell>
                                                {datos.modelo}
                                            </Table.Cell>
                                            <Table.Cell>
                                                {datos.serie}
                                            </Table.Cell>
                                            <Table.Cell>
                                                {datos.servicio}
                                            </Table.Cell>
                                        </Table.Row>
                                    </Table.Body>
                                </Table>

                                <Segment secondary>
                                    <Checkbox
                                        toggle
                                        label="Sin cobro"
                                        checked={checked}
                                        onChange={(e, data) =>
                                            setChecked(
                                                Boolean(data.checked)
                                            )
                                        }
                                    />

                                    <div style={{ marginTop: 14 }}>
                                        {checked ? (
                                            <Form>
                                                <Form.Field>
                                                    <label>Motivo</label>

                                                    <Dropdown
                                                        fluid
                                                        selection
                                                        search
                                                        placeholder="Selecciona motivo"
                                                        options={[...motivos].sort(
                                                            (a, b) =>
                                                                a.text.localeCompare(
                                                                    b.text
                                                                )
                                                        )}
                                                        value={motivo}
                                                        onChange={(
                                                            e,
                                                            { value }
                                                        ) =>
                                                            setMotivo(value)
                                                        }
                                                    />
                                                </Form.Field>
                                            </Form>
                                        ) : (
                                            <Form>
                                                <Form.Group widths="equal">
                                                    <Form.Input
                                                        label="Boleta"
                                                        placeholder="Ingrese Boleta"
                                                        value={boleta}
                                                        onChange={(e) =>
                                                            setBoleta(
                                                                e.target.value
                                                            )
                                                        }
                                                        maxLength={10}
                                                    />

                                                    <Form.Input
                                                        label="Monto"
                                                        placeholder="Ingrese Monto"
                                                        value={monto}
                                                        onChange={(e) =>
                                                            setMonto(
                                                                e.target.value
                                                            )
                                                        }
                                                        maxLength={12}
                                                    />
                                                </Form.Group>
                                            </Form>
                                        )}
                                    </div>
                                </Segment>
                            </>
                        )}
                    </Modal.Content>

                    <Modal.Actions>
                        <Button
                            basic
                            onClick={closeAllEntregaModals}
                        >
                            Cancelar
                        </Button>

                        <Button
                            color="teal"
                            onClick={() => guardarBoleta(datos)}
                            disabled={!datos}
                        >
                            <Icon name="check" />
                            Aceptar
                        </Button>
                    </Modal.Actions>
                </Modal>

                {/* ================= MODAL CÓDIGO ================= */}
                <Modal
                    open={openCodigo}
                    onClose={closeAllEntregaModals}
                    size="small"
                    closeIcon
                >
                    <Modal.Header>
                        <Icon name="key" color="teal" />
                        Cliente que retira
                    </Modal.Header>

                    <Modal.Content>
                        <Form size="small">
                            <Form.Input
                                label="Nombre retiro"
                                icon="user"
                                iconPosition="left"
                                placeholder="Nombre Retiro"
                                value={nombre_out}
                                onChange={(e) =>
                                    setNombre_out(e.target.value)
                                }
                            />

                            <Form.Input
                                label="Correo retiro"
                                icon="mail"
                                iconPosition="left"
                                placeholder="Correo Retiro"
                                value={correo_out}
                                onChange={(e) =>
                                    setCorreo_out(e.target.value)
                                }
                            />

                            <Form.Input
                                label="Teléfono cliente"
                                icon="phone"
                                iconPosition="left"
                                value={telefono_out}
                                placeholder="Cliente sin teléfono"
                                onChange={(e) =>
                                    setTelefono_out(e.target.value)
                                }
                            />

                            <Form.Input
                                type="number"
                                label="Código informado por cliente"
                                icon="barcode"
                                iconPosition="left"
                                placeholder="Ingrese Código"
                                value={codigo}
                                onChange={(e) =>
                                    setCodigo(e.target.value)
                                }
                            />
                        </Form>

                        <Message warning style={{ marginTop: 12 }}>
                            Cada vez que envíes un nuevo código por{" "}
                            <b>Email</b> o <b>SMS</b>, el código
                            anterior quedará inválido.
                        </Message>

                        <Message info>
                            Primero envía el código por el canal que
                            prefieras. Luego valida el código informado
                            por el cliente.
                        </Message>
                    </Modal.Content>

                    <Modal.Actions>
                        <Button
                            basic
                            onClick={() => {
                                setNombre_out("");
                                setCorreo_out("");
                                setTelefono_out("");
                                setCodigo("");
                            }}
                        >
                            Retira otro cliente
                        </Button>

                        <Button
                            color="blue"
                            disabled={btnEnviarCodigo || !datos}
                            onClick={() => generarNumero(datos)}
                            title={
                                btnEnviarCodigo
                                    ? "Debes esperar el tiempo restante"
                                    : "Generar y enviar nuevo código por correo"
                            }
                        >
                            <Icon name="mail" />
                            {btnEnviarCodigo && tiempo > 0
                                ? `Tiempo: ${tiempo}s`
                                : "Enviar Email"}
                        </Button>

                        <Button
                            color="orange"
                            disabled={btnEnviarCodigo || !datos}
                            onClick={() => generarNumeroSms(datos)}
                            title={
                                btnEnviarCodigo
                                    ? "Debes esperar el tiempo restante"
                                    : "Generar y enviar nuevo código por SMS"
                            }
                        >
                            <Icon name="comment alternate" />
                            {btnEnviarCodigo && tiempo > 0
                                ? `Tiempo: ${tiempo}s`
                                : "Enviar SMS"}
                        </Button>

                        <Button
                            color="green"
                            disabled={!datos}
                            onClick={() => validarNumero(datos)}
                        >
                            <Icon name="check" />
                            Validar Código
                        </Button>

                        {/* WhatsApp se mantiene sin modificar y desactivado */}
                        {/* <Button
                        color="green"
                        disabled={btnEnviarCodigo || !datos}
                        onClick={() => generarNumeroWhatsapp(datos)}
                    >
                        <Icon name="whatsapp" />
                        {btnEnviarCodigo && tiempo > 0
                            ? `Tiempo: ${tiempo}s`
                            : "Enviar WhatsApp"}
                    </Button> */}
                    </Modal.Actions>
                </Modal>

                {/* ================= CERTIFICADO BAJA ST ================= */}
                <Modal
                    open={openPdfBaja}
                    onClose={() => setOpenPdfBaja(false)}
                    size="large"
                    closeIcon
                >
                    <Modal.Header>
                        <Icon name="file pdf outline" color="red" />
                        Certificado Técnico de Baja ST
                    </Modal.Header>

                    <Modal.Content style={{ padding: 0 }}>
                        <PDFViewer
                            width="100%"
                            height="560"
                            style={{
                                border: "1px solid #ddd",
                            }}
                        >
                            <ReporteBajaSTPDF
                                ingreso={bajaIngreso}
                                presupuestoCab={bajaPresupuestoCab}
                                presupuesto={bajaPresupuesto}
                                bitacoraCab={bajaBitacoraCab}
                                bitacora={bajaBitacora}
                                baja={bajaRegistro}
                                usuario={bajaUsuario}
                                empresa={users.emp_id}
                            />
                        </PDFViewer>
                    </Modal.Content>

                    <Modal.Actions>
                        <Button
                            color="teal"
                            onClick={() => setOpenPdfBaja(false)}
                        >
                            <Icon name="close" />
                            Cerrar
                        </Button>
                    </Modal.Actions>
                </Modal>
            </Container>
        </Container>
    );
};

export default Entregar;